import styles from "../styles/productPage.module.css";

const RelatedSkeleton = ({ count = 1 }) => {
  return (
    <div className={styles.relatedskeleton}>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="product">
          <div className="imgcont skeleton"></div>
          <p className="skeleton skeleton-text"></p>
          <p className="skeleton skeleton-text2"></p>
        </div>
      ))}
    </div>
  );
}

export default RelatedSkeleton;
